import { Box, Typography } from '@mui/material';

import { stylesStepRadioTitle } from './directionRadioGroupsOptions.styles';

type DirectionRadioGroupOptionType = {
  directionLabel: string;
};

export const DirectionRadioGroupOption = ({ directionLabel }: DirectionRadioGroupOptionType) => (
  <Box>
    <Typography component='div' sx={stylesStepRadioTitle}>
      {directionLabel}
    </Typography>
  </Box>
);
